// extracted by mini-css-extract-plugin
module.exports = {"grid":"_133e42b0"};